import React from 'react';

/** File row for prescription/report entries */
export function FileRow({ entry, isDark, formatSize, onView }) {
  const isImage = entry.content_type?.startsWith('image/');
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0.375rem 0.5rem', borderRadius: '0.375rem',
      background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
      marginBottom: '0.25rem',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: '0.875rem', flexShrink: 0 }}>{isImage ? '🖼️' : '📄'}</span>
        <div style={{ minWidth: 0 }}>
          <div style={{
            fontSize: '0.6875rem', fontWeight: 500,
            color: isDark ? '#e8e9ed' : '#374151',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            {entry.file_name || 'File'}
          </div>
          <div style={{
            fontSize: '0.5rem', color: isDark ? '#4b5563' : '#d1d5db',
            display: 'flex', gap: '0.375rem',
          }}>
            {entry.file_size && <span>{formatSize(entry.file_size)}</span>}
            <span>{entry.added_by_name} • {entry.added_by_role}</span>
          </div>
        </div>
      </div>
      <button
        onClick={onView}
        style={{
          padding: '0.25rem 0.625rem', borderRadius: '0.375rem',
          border: `1px solid ${isDark ? 'rgba(13, 148, 136,0.3)' : 'rgba(13, 148, 136,0.2)'}`,
          background: isDark ? 'rgba(13, 148, 136,0.1)' : 'rgba(13, 148, 136,0.05)',
          color: '#0d9488', fontSize: '0.625rem', fontWeight: 600,
          cursor: 'pointer', flexShrink: 0,
        }}
      >
        👁 View
      </button>
    </div>
  );
}
